import { createFileRoute } from '@tanstack/react-router';

import { Logout } from '../auth';

export const Route = createFileRoute('/logout')({
  component: Logout,
});
